export enum DaypartRange {
  BREAKFAST = 'Breakfast (6am to 11am)',
  LUNCH = 'Lunch (11am to 2pm)',
  RUSH_HOUR = 'Rush hour (2pm to 6pm)',
  EVENING = 'Evening (6pm to 9pm)',
  OVERNIGHT = 'Overnight (9pm to 6am)'
}
